export default {
  title: {
    'zh-cn': '账号管理',
    'zh-tw': '賬號管理',
    'en': 'Account Management'
  },
  // 搜索表单
  phone: {
    'zh-cn': '手机',
    'zh-tw': '手機',
    'en': 'Phone'
  },
  mailbox: {
    'zh-cn': '邮箱',
    'zh-tw': '郵箱',
    'en': 'Email'
  },
  nickname: {
    'zh-cn': '昵称',
    'zh-tw': '暱稱',
    'en': 'Nickname'
  },
  // 按钮
  createAccount: {
    'zh-cn': '创建账号',
    'zh-tw': '創建賬號',
    'en': 'Create Account'
  },
  // 表格列
  serialNumber: {
    'zh-cn': '序号',
    'zh-tw': '序號',
    'en': 'No.'
  },
  phoneLabel: {
    'zh-cn': '手机',
    'zh-tw': '手機',
    'en': 'Phone'
  },
  mailboxLabel: {
    'zh-cn': '邮箱',
    'zh-tw': '郵箱',
    'en': 'Email'
  },
  nicknameLabel: {
    'zh-cn': '昵称',
    'zh-tw': '暱稱',
    'en': 'Nickname'
  },
  role: {
    'zh-cn': '角色',
    'zh-tw': '角色',
    'en': 'Role'
  },
  remark: {
    'zh-cn': '备注',
    'zh-tw': '備註',
    'en': 'Remark'
  },
  operation: {
    'zh-cn': '操作',
    'zh-tw': '操作',
    'en': 'Operation'
  },
  edit: {
    'zh-cn': '修改',
    'zh-tw': '修改',
    'en': 'Edit'
  },
  delete: {
    'zh-cn': '删除',
    'zh-tw': '刪除',
    'en': 'Delete'
  },
  // 删除确认
  deleteConfirm: {
    'zh-cn': '确定删除所选账号信息！',
    'zh-tw': '確定刪除所選賬號信息！',
    'en': 'Are you sure to delete the selected account information?'
  },
  // 对话框标题
  createAccountTitle: {
    'zh-cn': '创建账号',
    'zh-tw': '創建賬號',
    'en': 'Create Account'
  },
  editAccountTitle: {
    'zh-cn': '修改账号',
    'zh-tw': '修改賬號',
    'en': 'Edit Account'
  },
  // 表单标签
  phoneNumber: {
    'zh-cn': '手机号码',
    'zh-tw': '手機號碼',
    'en': 'Phone Number'
  },
  password: {
    'zh-cn': '密码',
    'zh-tw': '密碼',
    'en': 'Password'
  },
  confirmPassword: {
    'zh-cn': '确认密码',
    'zh-tw': '確認密碼',
    'en': 'Confirm Password'
  },
  roleLabel: {
    'zh-cn': '角色',
    'zh-tw': '角色',
    'en': 'Role'
  },
  boardAccess: {
    'zh-cn': '看板权限',
    'zh-tw': '看板權限',
    'en': 'Board Access'
  },
  boardDemoRate: {
    'zh-cn': '看板演示倍率',
    'zh-tw': '看板演示倍率',
    'en': 'Board Demo Rate'
  },
  // 占位符
  pleaseInputPhoneNumber: {
    'zh-cn': '请输入手机号码',
    'zh-tw': '請輸入手機號碼',
    'en': 'Please input phone number'
  },
  pleaseInputPassword: {
    'zh-cn': '请输入密码',
    'zh-tw': '請輸入密碼',
    'en': 'Please input password'
  },
  pleaseInputPasswordAgain: {
    'zh-cn': '请再次输入密码',
    'zh-tw': '請再次輸入密碼',
    'en': 'Please input password again'
  },
  pleaseInputNickname: {
    'zh-cn': '请输入昵称',
    'zh-tw': '請輸入暱稱',
    'en': 'Please input nickname'
  },
  pleaseInputEmail: {
    'zh-cn': '请输入邮箱',
    'zh-tw': '請輸入郵箱',
    'en': 'Please input email'
  },
  pleaseInputBoardDemoRate: {
    'zh-cn': '请输入看板演示倍率',
    'zh-tw': '請輸入看板演示倍率',
    'en': 'Please input board demo rate'
  },
  pleaseInputRemark: {
    'zh-cn': '请输入备注',
    'zh-tw': '請輸入備註',
    'en': 'Please input remark'
  },
  // 验证消息
  passwordMinLength: {
    'zh-cn': '密码最小长度6个字符',
    'zh-tw': '密碼最小長度6個字符',
    'en': 'Password minimum length is 6 characters'
  },
  passwordMaxLength: {
    'zh-cn': '密码最大长度32个字符',
    'zh-tw': '密碼最大長度32個字符',
    'en': 'Password maximum length is 32 characters'
  },
  passwordNotMatch: {
    'zh-cn': '两次密码输入不一致',
    'zh-tw': '兩次密碼輸入不一致',
    'en': 'Passwords do not match'
  },
  phoneNumberLength: {
    'zh-cn': '手机号码长度为11个字符',
    'zh-tw': '手機號碼長度為11個字符',
    'en': 'Phone number length should be 11 characters'
  },
  nicknameMaxLength: {
    'zh-cn': '昵称长度不超过64',
    'zh-tw': '暱稱長度不超過64',
    'en': 'Nickname length should not exceed 64'
  },
  pleaseInputNumber: {
    'zh-cn': '请输入数字',
    'zh-tw': '請輸入數字',
    'en': 'Please input number'
  },
  rateMustGreaterThanZero: {
    'zh-cn': '倍率需大于0',
    'zh-tw': '倍率需大於0',
    'en': 'Rate must be greater than 0'
  },
  rateOnlyOneDecimal: {
    'zh-cn': '倍率仅支持一位小数',
    'zh-tw': '倍率僅支持一位小數',
    'en': 'Rate only supports one decimal place'
  },
  // 加载提示
  processing: {
    'zh-cn': '正在执行，请稍后。。。',
    'zh-tw': '正在執行，請稍後。。。',
    'en': 'Processing, please wait...'
  },
  // 硬编码角色名称
  commonUser: {
    'zh-cn': '普通用户',
    'zh-tw': '普通用戶',
    'en': 'Common User'
  }
}

